export default {"src":"/_next/static/media/Public_form_afterstate.d976f6a0.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};